<div
  y42MonacoEditor
  class="m-2 flex-1 overflow-hidden"
  [fileName]="path"
  [options]="{ theme: 'git' }"
  (editorInitialized)="annotate($event)"
></div>
